import MainLayout from '@/common/components/layouts/MainLayout';
import useInfinityScroll from '@/common/hooks/useInfinityScroll';
import useModal from '@/common/hooks/useModal';
import LoadingPage from '@/common/pages/LoadingPage';
import { useInfiniteQuery } from '@tanstack/react-query';
import { Box } from 'styled-system/jsx';
import { EducationFilter } from '../components/education-list/EducationFilter';
import NoEducationList from '../components/education-list/NoEducationList';
import EducationCard from '../components/EducationCard';
import CategoryFilterModal from '../components/modals/CategoryFilterModal';
import { useEducationParams } from '../hooks/useEducationParams';
import { getEducationListInfiniteQueryOptions } from '../queries/getEducationList/getEducationListQueryOptions';
import { useNavigate } from 'react-router-dom';
import { EDUCATION_LINKS } from '../EducationLinks';

const EducationListPage = () => {
  const navigate = useNavigate();
  return (
    <MainLayout
      header="titleHeader"
      title="دسته بندی ها"
      backwardHandler={() => navigate(EDUCATION_LINKS.education)}
    >
      <EducationList />
    </MainLayout>
  );
};

function EducationList() {
  const { selectedCategories, categoriesIds, hasSelection, clearCategories } =
    useEducationParams();

  const { data, isPending, fetchNextPage } = useInfiniteQuery(
    getEducationListInfiniteQueryOptions({ categories: categoriesIds }),
  );
  const { observerRefCallback } = useInfinityScroll(fetchNextPage);
  const { closeModal, open, openModal } = useModal();

  if (isPending) {
    return <LoadingPage />;
  }

  const allEducations = data?.pages?.flatMap((page) => page.results) ?? [];
  [];

  const isEmpty = !isPending && allEducations.length === 0;
  const selectionText =
    selectedCategories.length === 1
      ? selectedCategories[0].title
      : `${selectedCategories.length} مورد`;

  return (
    <>
      <Box
        padding="15px 0px"
        mb={40}
        display="flex"
        flexDirection="column"
        gap={16}
      >
        <EducationFilter
          hasSelection={hasSelection}
          selectionText={selectionText}
          onClear={clearCategories}
          onClick={openModal}
        />

        {isPending ? (
          <LoadingPage />
        ) : isEmpty ? (
          <NoEducationList />
        ) : (
          allEducations?.map((item) => (
            <Box key={item.id} ref={observerRefCallback}>
              <EducationCard {...item} cardSize="normal" />
            </Box>
          ))
        )}
      </Box>

      <CategoryFilterModal closeModal={closeModal} open={open} />
    </>
  );
}

export default EducationListPage;
